<template>
  <FieldWrapper
    :key="key"
    :label="tree.label"
    :state="state"
    :configs="configs"
    bold
  >
    <template #after>
      <FieldSubTree
        v-model="values"
        :options="tree.children"
        :disabled="disabled"
      />
    </template>
  </FieldWrapper>
</template>

<script>
import FieldSubTree from './FieldSubTree'
import FieldWrapper from './FieldWrapper'

export default {
  components: {
    FieldWrapper,
    FieldSubTree
  },

  props: {
    tree: {},
    value: {},
    state: {},

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    const values = Array.isArray(this.value) ? [...this.value] : []
    const message = null
    const key = `${values}` || '0'
    return { values, message, key }
  },

  computed: {
    configs () {
      return {
        fieldWidth: 'col-12'
      }
    }
  },

  watch: {
    values (values) {
      if (isEqual(values, this.value)) return
      this.$emit('input', values)
    },

    value (value) {
      const values = Array.isArray(value) ? [...value] : []
      if (isEqual(values, this.values)) return
      this.values = values
      this.key = `${values}` || '0'
    }
  }
}

const isEqual = (source, target) => JSON.stringify(source) === JSON.stringify(target)
</script>
